import * as React from "react";
import { Link } from "react-router-dom";

interface DevicesActionButtonsProps {
    submitting: boolean;
    automationIdPrefix?: string;
    onSaveClick: () => void;
}

export const DevicesActionButtons = ({ submitting, automationIdPrefix, onSaveClick }: DevicesActionButtonsProps) => {
    return (
        <div className="h2 pull-right">
            <button className="btn btn-primary" type="submit" disabled={submitting} onClick={onSaveClick} data-automationid={`${automationIdPrefix}_Save`}>
                Save
            </button>&nbsp;
            <Link className="btn btn-primary btn-outline" to="/deviceadministration" data-automationid={`${automationIdPrefix}_ReturnToList`}>
                Return to List
            </Link>
        </div>
    );
}
